// Утилита оставлена для возможности переключения на локаль в зависимости от используемого языка и страны
// т.е. в итоговом виде он может принять вид селектора
// createSelector(getLang, getCountryCode, (lang, countryCode) => `${lang}-${countryCode}`);
export const getLocale = () => `ru-RU`;
